module.exports = __webpack_public_path__ + "static/media/ankh.1398d16b.svg";